export const isVisitor = (list: any[], userId: any) =>
  list.find(
    (listUser: any) =>
      (listUser?.id
        ? +listUser.id === +userId
        : +listUser.userId === +userId) && +listUser.type === 2,
  );

export const checkEventsDates = (startDate: any, endDate: any) =>
  +new Date(endDate) >= +new Date() && +new Date(startDate) <= +new Date();

export const checkEventIsEnded = (endDate: any) =>
  +new Date(endDate) < +new Date();

export const checkEventIsStarted = (startDate: any) =>
  +new Date(startDate) > +new Date();
